import { Breakpoint } from '@mui/system'

/**
 * - Breakpoints to use throughout owner onboarding based on figma
 * - https://www.figma.com/file/uoRm7pgK5O0vQgHBN2irLS/Homeowner-Wizard?node-id=379%3A1365
 */
const values = {
  xs: 375,
  sm: 768,
  md: 1140,
  lg: 1400,
  xl: 1920,
}

/**
 * Get media query up from certain breakpoint
 * @param {Breakpoint} bp - the breakpoint to get media query from
 * @returns {string} - media querys
 */
const up = (bp: Breakpoint): string => `@media (min-width: ${values[bp]}px)`

/**
 * Get media query down from certain breakpoint
 * @param {Breakpoint} bp - the breakpoint to get media query from
 * @returns {string} - media query
 */
const down = (bp: Breakpoint): string => `@media (max-width: ${values[bp]}px)`

const breakpoints = {
  values,
  up,
  down,
}

export default breakpoints
